import moment from 'moment';

// Copy of comparePostingsByDateRoom in ui/src/screens/pages/Transaction/FOCheckout/calculations.ts,
// which mirrors postingOrderBy in api/src/common/checkoutPostingSql.ts. Keep all three in step:
// checkout bill rows go by calendar day, then room number (all-digit names numerically, then
// other names alphabetically), then room charges before other charges, then time.

const POSTING_DATE_FORMATS = [
  'YYYY/MM/DD HH:mm:ss',
  'YYYY/MM/DD HH:mm',
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DDTHH:mm:ss.SSSZ',
  'YYYY-MM-DDTHH:mm:ssZ',
  'DD-MM-YYYY HH:mm:ss',
  'DD-MM-YYYY HH:mm',
];

const postingMoment = (d: any) => moment(d, POSTING_DATE_FORMATS);

// Room charges first (tariff, plan, extra bed, extra child); F&B and other heads after.
const postingHeadRank = (hdType: any) => {
  const n = Number(hdType);
  return n >= 1 && n <= 4 ? n : 9;
};

export const comparePostingsByDateRoom = (a: any, b: any): number => {
  const ma = postingMoment(a?.ps_date);
  const mb = postingMoment(b?.ps_date);
  const dayA = ma.isValid() ? ma.format('YYYY-MM-DD') : '9999-12-31';
  const dayB = mb.isValid() ? mb.format('YYYY-MM-DD') : '9999-12-31';
  if (dayA !== dayB) return dayA < dayB ? -1 : 1;

  const ra = String(a?.ps_roomname ?? '');
  const rb = String(b?.ps_roomname ?? '');
  const numA = /^\d+$/.test(ra);
  const numB = /^\d+$/.test(rb);
  if (numA !== numB) return numA ? -1 : 1;
  if (numA && numB && Number(ra) !== Number(rb)) return Number(ra) - Number(rb);
  const byName = ra.localeCompare(rb, undefined, { sensitivity: 'base' });
  if (byName !== 0) return byName;

  const ha = postingHeadRank(a?.hd_type);
  const hb = postingHeadRank(b?.hd_type);
  if (ha !== hb) return ha - hb;

  const ta = ma.isValid() ? ma.valueOf() : Number.MAX_SAFE_INTEGER;
  const tb = mb.isValid() ? mb.valueOf() : Number.MAX_SAFE_INTEGER;
  return ta - tb;
};

/** Stable sort (ties keep their incoming order) - does not mutate `rows`. */
export const sortPostingsByDateRoom = <T>(rows: T[]): T[] =>
  rows
    .map((row, i) => ({ row, i }))
    .sort((x, y) => comparePostingsByDateRoom(x.row, y.row) || x.i - y.i)
    .map(({ row }) => row);
